import React, { useState, useEffect } from "react";
import {
  Paper, Grid2, TextField, Typography, Autocomplete,
  TableCell, Table, TableContainer, TableRow, TableBody, TableHead,
  Button, InputAdornment, Chip, Modal, Box, ListItemText, MenuItem
} from "@mui/material";
import ShowInformation from "./subs/ShowInformation";
import FormularioAcreedor from "./subs/FormularioAcreedor";
import { useSelector } from "react-redux";
import { getServiciosLineaNegocio, getAcreedores } from "../Redux/GeneralDuck";
import { useDispatch } from "react-redux";
import Swal from "sweetalert2";
import { setCargaDatos } from "../Redux/V2/ContratoRedux";
import { styleModalAsignaCausas } from "./styles/modal";
import { useFetcher } from "react-router-dom";
import { createFilterOptions } from '@mui/material/Autocomplete';
import AddIcon from '@mui/icons-material/Add'
import { SkipNext } from '@mui/icons-material';

const formatter = new Intl.NumberFormat("es-CL"); // formato CLP (Chile)

const Servicios = ({ from, onChangeSave }) => {
  var dispatch = useDispatch();
  const entrevista = useSelector((store) => store.contratoV2.Entrevista);
  const serviciosSistema = useSelector((store) => store.general.seriviciosLN);
  const acreedoresSistema = useSelector((store) => store.general.acreedores);
  const contrato = useSelector((store) => store.contratoV2.contrato);
  const causas = useSelector((store) => store.contratoV2.Causas);
  const actualizacion = useSelector((store) => store.contratoV2.Actualizacion);

  // 🔒 NUEVO: estados de contrato para bloqueo
  const contratoCancelado = useSelector((store) => store.contratoV2.ContratoCancelado);
  const contratoFiniquitado = useSelector((store) => store.contratoV2.ContratoFiniquitado);
  const contratoFirmado = useSelector((store) => store.contratoV2.ContratoFirmado);

  //const [disabledComponent, setDisabledComponent] = useState(false);




  const [serviciosSeleccionados, setServiciosSeleccionados] = useState([]);
  const [showAsignarCausas, setShowAsignarCausas] = useState(false);
  const [causasList, setCausasList] = useState([]);
  const [disabledCambioEstrategia, setDisabledCambioEstrategia] = useState(false);

  const MAX_MONTO_SERVICIO = 100000000;

  const disabledComponent = actualizacion?.actualizacion?.status == 1
  const bloqueadoTotalmente =
    !!contratoCancelado?.cancelado ||
    !!contratoFiniquitado?.finiquitado || (contratoFirmado?.firmado && !disabledComponent)


  const filterOptions = createFilterOptions({
    matchFrom: 'any',
    stringify: (option) => option.name,
  });

  // Ahora, unificamos la lógica de inicialización en un solo useEffect
  useEffect(() => {
    if (entrevista && entrevista.contractId != null) {
      dispatch(getServiciosLineaNegocio(entrevista.contractId));
      dispatch(getAcreedores());
      console.log(3 + "-" + entrevista.contractId)
      dispatch(setCargaDatos("contrato", "get", entrevista.contractId));
    }
  }, [entrevista, actualizacion]);

  useEffect(() => {
    if (actualizacion?.actualizacion?.status == 1) { //actualizacion en curso, cargar el defendido de la actualizacion
      setDisabledCambioEstrategia(true);// bloqueado para actualizacion, no para cambio de estrategia 
      if (actualizacion.actualizacionModelos && actualizacion.actualizacionModelos.length > 0) {
        actualizacion.actualizacionModelos.sort((a, b) => b.id - a.id);
        const _servicioAct = actualizacion.actualizacionModelos.find(obj => obj.model == "servicio");

        //const _servicioDelAct = actualizacion.actualizacionModelos.find(obj => obj.model == "servicio/delete");

        /*if (_servicioAct != null) {
          if(_servicioDelAct && _servicioDelAct){
            var servicioJson = JSON.parse(_servicioAct.json).servicios;
            const serviciosEliminados = JSON.parse(_servicioDelAct.json);
            console.log(serviciosEliminados)
            servicioJson = servicioJson.filter(srv => !serviciosEliminados.idService == srv.idService);
            setServiciosSeleccionados(servicioJson);
          }else
            setServiciosSeleccionados(JSON.parse(_servicioAct.json).servicios);
          return
        }*/

        if (_servicioAct != null) {
          setServiciosSeleccionados(JSON.parse(_servicioAct.json).servicios);
          return
        }
      }
    }
    setServiciosSeleccionados(Array.isArray(contrato) ? contrato : []); //servicios y acreedores
  }, [contrato]);


  useEffect(() => {
    if (actualizacion?.actualizacion?.status == 1) { //actualizacion en curso, cargar el defendido de la actualizacion
      if (actualizacion.actualizacionModelos && actualizacion.actualizacionModelos.length > 0) {
        const _causasAct = actualizacion.actualizacionModelos.find(obj => obj.model == "causas");
        if (_causasAct != null) {
          setCausasList(JSON.parse(_causasAct.json)?.causasGcc ?? []);
          return
        }
      }
    }
    setCausasList(causas.causasGcc || []);
  }, [causas?.causasGcc]);

  const cambiarMontoServicio = (e, idService) => {
    if (bloqueadoTotalmente) return; // 🔒 early return si está bloqueadoTotalmente
    const { value } = e.target;
    setServiciosSeleccionados((prev) =>
      prev.map((obj) =>
        obj.idService === idService ? { ...obj, monto: Number(value) } : obj
      )
    );
  };

  const agregarAcreedorServicio = (idService, acreedorSeleccionado) => {
    if (bloqueadoTotalmente) return; // 🔒
    const auxAcreedor = acreedorSeleccionado;
    setServiciosSeleccionados((prev) =>
      prev.map((obj) =>
        obj.idService === idService
          ? { ...obj, acreedores: [...(obj.acreedores || []), auxAcreedor] }
          : obj
      )
    );
  };

  const handleChangeServicios = (event, newValue) => {
    if (bloqueadoTotalmente) return; // 🔒
    const unique = newValue.filter(
      (obj, index, self) =>
        index === self.findIndex((t) => t.idService === obj.idService)
    );

    setServiciosSeleccionados((prevServicios) => {

      /*
        // Detectar si se eliminó alguno
        const eliminados = prevServicios.filter(
          (s) => !newValue.some((n) => n.idService === s.idService)
        );

        if (eliminados.length > 0) {
          await quitarServici (servicio)
          return prevServicios; // no actualizamos, se mantiene igual
        }*/

      return unique.map((servicioNuevo) => {
        const servicioExistente = prevServicios.find(
          (s) => s.idService === servicioNuevo.idService
        );

        if (servicioExistente) {
          return servicioExistente;
        }

        return {
          ...servicioNuevo,
          contractServiceId: 0,
          acreedores: [],
          monto: servicioNuevo.monto || 0, // Aseguramos que 'monto' exista
        };
      });
    });
  };

  const quitarServicio = async (servicio) => {
    if (bloqueadoTotalmente) return; // 🔒
    if (!servicio.contractServiceId || servicio.contractServiceId === 0) {
      setServiciosSeleccionados((prev) =>
        prev.filter((s) => s.idService !== servicio.idService)
      );
      return;
    }

    const result = await Swal.fire({
      title: "¿Estás seguro?",
      text: `Se quitará el servicio "${servicio.name}". Esta acción no se puede deshacer.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sí, ¡quítalo!",
      cancelButtonText: "Cancelar",
    });

    if (!result.isConfirmed) {
      return; // Si el usuario cancela, no hacemos nada
    }

    const aux = {
      contractServiceId: servicio.contractServiceId,
      contractId: entrevista.contractId,
      interviewId: entrevista.id,
    };

    if (actualizacion?.actualizacion?.status == 1) { //si es actualizacion en curso
      var payload = {
        json: JSON.stringify(aux),
        model: "servicio/delete",
        actualizacionId: actualizacion.actualizacion.id,
      }
      await dispatch(setCargaDatos("Actualizacion", "put", payload));
      return
    }

    const exito = await dispatch(setCargaDatos("contrato", "delete", aux));

    if (exito) {
      Swal.fire({
        icon: "success",
        title: "¡Eliminado!",
        text: "El servicio ha sido quitado correctamente.",
        showConfirmButton: false,
        timer: 1500,
      });
      dispatch(setCargaDatos("contrato", "get", entrevista.contractId));
    } else {
      Swal.fire({
        icon: "error",
        title: "Error al eliminar",
        text: "No se pudo quitar el servicio. Por favor, intente nuevamente.",
      });
    }

    return
  };

  const quitarAcreedor = async (contractServiceId, acreedor) => {
    if (bloqueadoTotalmente) return; // 🔒
    if (!acreedor.id || acreedor.id === 0) {
      setServiciosSeleccionados((prev = []) =>
        prev.map((servicio) => {
          if (servicio.contractServiceId === contractServiceId) {
            return {
              ...servicio,
              acreedores: servicio.acreedores.filter((a) => a !== acreedor),
            };
          }
          return servicio;
        })
      );
      /*
      Swal.fire({
        icon: "info",
        title: "Acreedor quitado",
        text: "El acreedor ha sido quitado de la lista localmente.",
        showConfirmButton: false,
        timer: 2000,
      });*/
      return;
    }

    const result = await Swal.fire({
      title: "¿Estás seguro?",
      text: `Se quitará el acreedor "${acreedor.name}" de la base de datos.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sí, ¡quítalo!",
      cancelButtonText: "Cancelar",
    });

    if (!result.isConfirmed) {
      return;
    }

    try {
      var aux = {
        acreedorId: acreedor.id,
        contractServiceId,
        interviewId: entrevista.id,
        contractId: entrevista.contractId,
      };

      if (actualizacion?.actualizacion?.status == 1) { //si es actualizacion en curso
        // se debe quitar el acreedor 
        /*
        var payload = {
          json: JSON.stringify(aux),
          model: "acreedor/delete",
          actualizacionId: actualizacion.actualizacion.id,
        }
        await dispatch(setCargaDatos("Actualizacion", "put", payload)); // se supone que se elimina cuando el acrredor existe en bd, por lo tanto hay que copiar el eliminar acreedor
        */
        setServiciosSeleccionados((prev = []) =>
          prev.map((servicio) => {
            if (servicio.contractServiceId === contractServiceId) {
              return {
                ...servicio,
                acreedores: servicio.acreedores.filter((a) => a !== acreedor),
              };
            }
            return servicio;
          })
        );
        return
      }

      const exito = await dispatch(setCargaDatos("contrato", "patch", aux));

      if (exito) {
        setServiciosSeleccionados((prev = []) =>
          prev.map((servicio) => {
            if (servicio.contractServiceId === contractServiceId) {
              return {
                ...servicio,
                acreedores: servicio.acreedores.filter(
                  (a) => a.id !== acreedor.id
                ),
              };
            }
            return servicio;
          })
        );
        Swal.fire(
          "¡Eliminado!",
          "El acreedor ha sido quitado de la base de datos.",
          "success"
        );
        dispatch(setCargaDatos("contrato", "get", entrevista.contractId));
      } else {
        Swal.fire("Error", "No se pudo quitar el acreedor.", "error");
      }
    } catch (error) {
      console.error("Error al quitar acreedor:", error);
      Swal.fire("Error", "Ocurrió un problema de comunicación.", "error");
    }
  };

  const handleSubmit = async (checkCausas) => {
    if (bloqueadoTotalmente) return; // 🔒

    if (
      serviciosSeleccionados == null ||
      serviciosSeleccionados == undefined ||
      serviciosSeleccionados.length == 0
    ) {
      Swal.fire({
        icon: "error",
        title: "Sin Servicios",
        text: `No hay servicios seleccionados, no puede continuar`,
      });
      return false;
    }
    const invalido = serviciosSeleccionados.some(
      (servicio) => servicio.monto < servicio.minAmount
    );
    if (invalido && actualizacion?.actualizacion?.status != 1) {
      Swal.fire({
        icon: "error",
        title: "Monto inválido",
        text: `Hay servicios con monto menor al mínimo permitido`,
      });
      return false;
    }


    // ✅ NUEVO: Validación de tope total (100 millones)
    const LIMITE_TOTAL_SERVICIOS = 100000000; // 100 MM
    const totalServicios = (serviciosSeleccionados || []).reduce(
      (sum, s) => sum + (Number(s.monto) || 0),
      0
    );
    if (totalServicios > LIMITE_TOTAL_SERVICIOS) {
      Swal.fire({
        icon: "error",
        title: "Monto total excedido",
        html: `
          <p><b>Total servicios:</b> $ ${formatter.format(totalServicios)}</p>
          <p><b>Límite permitido:</b> $ ${formatter.format(LIMITE_TOTAL_SERVICIOS)}</p>
          <p>Reduce el costo total antes de continuar.</p>
        `,
      });
      return false;
    }


    if (!checkCausas && causasList.length == 0) {
      const result = await Swal.fire({
        title: "No ha agregado causas judiciales para este contrato",
        text: `¿Está seguro que desea continuar?`, //Si desea agregar debe volver a la hoja de atención. Despues no podra registrarlas,
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Sí, continuar",
        cancelButtonText: "Cancelar",
      });

      if (!result.isConfirmed) return;
      checkCausas = true;
    }

    if (!checkCausas && causasList.length > 0) {
      setShowAsignarCausas(true);
      return;
    }

    var guardarCausas = false;
    if (checkCausas && causasList.length > 0) {
      const allValid = causasList.every((item) => item.serviceId !== 0);
      if (!allValid) {
        Swal.fire({
          icon: "error",
          title: "Asignación pendiente",
          text: `No ha asignado todas las causas.`,
        });
        return;
      }
      guardarCausas = true;
    }


    try {
      var aux = {
        servicios: serviciosSeleccionados,
        contractId: entrevista.contractId,
        interviewId: entrevista.id,
      };

      if (actualizacion?.actualizacion?.status == 1) { //si es actualizacion en curso

        var payload = {
          json: JSON.stringify(aux),
          model: "servicio",
          actualizacionId: actualizacion.actualizacion.id,
        }

        await dispatch(setCargaDatos("Actualizacion", "put", payload));
      } else {
        await dispatch(setCargaDatos("contrato", "post", aux));
        await dispatch(setCargaDatos("Entrevista", "get", entrevista.id));
      }



      if (guardarCausas) {
        //
        setShowAsignarCausas(false);
        const aux = {
          interviewId: entrevista.id,
          causasPjud: causas.causasPjud,
          causasGcc: causasList,
        };
        try {

          if (actualizacion?.actualizacion?.status == 1) { //si es actualizacion en curso
            var payload = {
              json: JSON.stringify(aux),
              model: "causas",
              actualizacionId: actualizacion.actualizacion.id,
            }
            await dispatch(setCargaDatos("Actualizacion", "put", payload));
          } else {
            const exito = await dispatch(setCargaDatos("Causas", "post", aux));
            if (exito) {
              await dispatch(setCargaDatos("Causas", "get", entrevista.id));
            }
          }

        } catch (error) {
          console.error("Error en handleSubmit:", error);
          Swal.fire({
            icon: "error",
            title: "Error de Conexión",
            text: "No se pudo comunicar con el servidor.",
          });
        }
      }

      if (onChangeSave) onChangeSave(from);
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error al guardar",
        text: `No se pudieron guardar los datos, intente nuevamente`,
      });
    }
  };

  const handleAsignarServicioCausa = (e, row) => {
    if (bloqueadoTotalmente) return; // 🔒
    setCausasList((prev) =>
      prev.map((item) =>
        item.id === row.id ? { ...item, serviceId: e.target.value } : item
      )
    );
  };

  const updateIdService = (index, newValue) => {
    setServiciosSeleccionados(prev =>
      prev.map((s, i) => (i === index ? {
        ...s,
        idService: newValue.idService,
        name: newValue.name,
        minAmount: newValue.minAmount,
        maxCuota: newValue.maxCuota,
      } : s))
    );
  };

  return (
    <Paper>
      <ShowInformation from={from} />
      <Grid2 container spacing={2} sx={{ mt: 2, p: 3 }}>
        <Grid2 sx={{ mb: 3 }} size={12}>
          <Autocomplete
            multiple
            //options={serviciosSistema}
            options={Array.isArray(serviciosSistema) ? serviciosSistema : []}
            getOptionLabel={(option) => option?.name ?? ""}
            isOptionEqualToValue={(option, value) =>
              option.idService === value.idService
            }
            disabled={bloqueadoTotalmente || disabledComponent}
            //filterOptions={filterOptions}
            value={serviciosSeleccionados}
            onChange={(e, newValue) => handleChangeServicios(e, newValue)}
            filterSelectedOptions
            renderTags={(value, getTagProps) =>
              value.map((op, i) => (
                <Chip
                  key={op.idService}
                  label={op.name}
                  {...getTagProps({ index: i })}
                />
              ))
            }
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                label="Selecciona servicios"
                placeholder="Buscar..."
                disabled={(bloqueadoTotalmente || disabledComponent)}
              />
            )}
          />
        </Grid2>

        <Grid2 sx={{ mb: 3 }} size={12}>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ textAlign: "center" }}>Servicio</TableCell>
                  <TableCell sx={{ textAlign: "center" }}>Costo del Servicio</TableCell>
                  <TableCell sx={{ textAlign: "center" }}>Monto Minimo Servicio</TableCell>
                  <TableCell sx={{ textAlign: "center" }}>Tope de Cuotas</TableCell>
                  <TableCell sx={{ textAlign: "center" }}>Quitar</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {serviciosSeleccionados?.map((row, ii) => (
                  <TableRow
                    key={ii}
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  >
                    <TableCell component="th" scope="row" sx={{ textAlign: "center" }}>
                      {actualizacion?.actualizacion?.status == 1 && actualizacion?.actualizacion?.type == 2 ?
                        <Autocomplete
                          disableClearable
                          options={Array.isArray(serviciosSistema) ? serviciosSistema : []}
                          getOptionLabel={(option) => option?.name ?? ""}
                          isOptionEqualToValue={(option, value) => option.idService === value.idService}
                          value={row}
                          onChange={(e, newValue) => updateIdService(ii, newValue)}
                          filterSelectedOptions
                          renderTags={(value, getTagProps) =>
                            value.map((op, i) => (
                              <Chip key={op.idService} label={op.name} {...getTagProps({ index: i })} />
                            ))
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              variant="outlined"
                              label="Cambiar servicio"
                              placeholder="Buscar..."
                            />
                          )}
                        />
                        :
                        row.name
                      }


                    </TableCell>


                    {/* <TableCell align="right">
                      <TextField
                        fullWidth
                        sx={{ align: "center" }}
                        label="Costo del Servicio"
                        name="monto"
                        value={row.monto ? formatter.format(row.monto) : ""}
                        onChange={(e) => {
                          if (bloqueadoTotalmente && !disabledComponent) return; // 🔒
                          const soloNumeros = e.target.value.replace(/\D/g, "");
                          cambiarMontoServicio({ target: { value: soloNumeros ? Number(soloNumeros) : 0, }, }, row.idService);
                        }}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">$</InputAdornment>
                          ),
                          inputMode: "numeric",
                          pattern: "[0-9]*",
                          readOnly: bloqueadoTotalmente && !disabledComponent, // 🔒 lectura si bloqueadoTotalmente
                        }}
                        disabled={bloqueadoTotalmente && !disabledComponent} // 🔒
                        error={row.monto < row.minAmount || isNaN(row.monto)}
                        helperText={
                          row.monto <= row.minAmount || isNaN(row.monto)
                            ? "Monto menor al monto minimo permitido"
                            : ""
                        }
                      />
                    </TableCell> */}
                    <TableCell align="right">
                      {/*<TextField
                        fullWidth
                        sx={{ align: "center" }}
                        label="Costo del Servicio"
                        name="monto"
                        value={row.monto ? formatter.format(row.monto) : ""}
                        onChange={(e) => {
                          if (bloqueadoTotalmente && !disabledComponent) return; // 🔒
                          const soloNumeros = e.target.value.replace(/\D/g, "");
                          let value = soloNumeros ? Number(soloNumeros) : 0;

                          if (value > MAX_MONTO_SERVICIO) {
                            Swal.fire({
                              icon: "warning",
                              title: "Tope excedido",
                              text: `El costo del servicio no puede superar $ ${formatter.format(MAX_MONTO_SERVICIO)}.`
                            });
                            value = MAX_MONTO_SERVICIO; // clamp a 100.000.000
                          }

                          cambiarMontoServicio({ target: { value } }, row.idService);
                        }}
                        InputProps={{
                          startAdornment: <InputAdornment position="start">$</InputAdornment>,
                          inputMode: "numeric",
                          pattern: "[0-9]*",
                          readOnly: bloqueadoTotalmente && !disabledComponent,
                        }}
                        disabled={bloqueadoTotalmente && !disabledComponent}
                        error={
                          actualizacion?.actualizacion?.status != 1 ? (
                          isNaN(row.monto) ||
                          row.monto < row.minAmount ||
                          Number(row.monto) > MAX_MONTO_SERVICIO
                          )
                          :
                          null
                        }
                        helperText={
                          actualizacion?.actualizacion?.status != 1 ?
                            Number(row.monto) > MAX_MONTO_SERVICIO ?
                              `Monto no puede superar $ ${formatter.format(MAX_MONTO_SERVICIO)}`
                              : (row.monto <= row.minAmount || isNaN(row.monto))
                              ? "Monto menor al monto minimo permitido"
                              : ""
                              :""
                        }
                      />*/}
                      <TextField
                        fullWidth
                        sx={{ align: "center" }}
                        label="Costo del Servicio"
                        name="monto"
                        value={row.monto === null || row.monto === undefined ? "" : formatter.format(row.monto)}
                        onChange={(e) => {
                          if (bloqueadoTotalmente && !disabledComponent) return;

                          // permitir vacío mientras escribe
                          const raw = e.target.value.replace(/\D/g, "");
                          if (raw === "") {
                            cambiarMontoServicio({ target: { value: "" } }, row.idService);
                            return;
                          }

                          let value = Number(raw);

                          if (value > MAX_MONTO_SERVICIO) {
                            Swal.fire({
                              icon: "warning",
                              title: "Tope excedido",
                              text: `El costo del servicio no puede superar $ ${formatter.format(MAX_MONTO_SERVICIO)}.`,
                            });
                            value = MAX_MONTO_SERVICIO;
                          }

                          cambiarMontoServicio({ target: { value } }, row.idService);
                        }}
                        InputProps={{
                          startAdornment: <InputAdornment position="start">$</InputAdornment>,
                          inputMode: "numeric",
                          pattern: "[0-9]*",
                          readOnly: bloqueadoTotalmente && !disabledComponent,
                        }}
                        disabled={bloqueadoTotalmente && !disabledComponent}
                        error={
                          actualizacion?.actualizacion?.status != 1
                            ? isNaN(row.monto) ||
                            row.monto < row.minAmount ||
                            Number(row.monto) > MAX_MONTO_SERVICIO
                            : null
                        }
                        helperText={
                          actualizacion?.actualizacion?.status != 1
                            ? Number(row.monto) > MAX_MONTO_SERVICIO
                              ? `Monto no puede superar $ ${formatter.format(MAX_MONTO_SERVICIO)}`
                              : row.monto <= row.minAmount || isNaN(row.monto)
                                ? "Monto menor al monto minimo permitido"
                                : ""
                            : ""
                        }
                      />
                    </TableCell>

                    <TableCell sx={{ textAlign: "center" }}> $ {row.minAmount ? formatter.format(row.minAmount) : ""}{" "} </TableCell>
                    <TableCell sx={{ textAlign: "center" }}>{row.maxCuota}</TableCell>
                    <TableCell sx={{ textAlign: "center" }}>
                      <Button
                        variant="contained"
                        color="secondary"
                        onClick={() => quitarServicio(row)}
                        disabled={bloqueadoTotalmente} // 🔒
                      >Quitar</Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid2>
        {entrevista?.lineaNegocioId == 1
          ? serviciosSeleccionados.map((servicio, ind) => (
            <Grid2 key={ind} sx={{ mb: 3 }} size={12}>
              <Typography variant="h6" sx={{ mb: 3, fontWeight: "bold" }}>
                {" "}
                Acreedores para: {servicio.name}
              </Typography>

              <FormularioAcreedor
                key={ind}
                servicio={servicio}
                acreedoresSistema={acreedoresSistema}
                agregarAcreedorServicio={agregarAcreedorServicio}
                disabled={bloqueadoTotalmente} // 🔒 pasar estado al sub-componente
                indice={ind}
              />
              <br />
              <br />
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ textAlign: "center" }}>Acreedor</TableCell>
                    <TableCell sx={{ textAlign: "center" }}>Monto</TableCell>
                    <TableCell sx={{ textAlign: "center" }}>Detalle</TableCell>
                    <TableCell sx={{ textAlign: "center" }}>Quitar</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {servicio?.acreedores?.map((acreedor, index) => (
                    <TableRow
                      key={index}
                      sx={{
                        "&:last-child td, &:last-child th": { border: 0 },
                      }}
                    >
                      <TableCell component="th" scope="row" sx={{ textAlign: "center" }}>
                        {" "}
                        {acreedor.name ?? "_"}{" "}
                      </TableCell>
                      <TableCell sx={{ textAlign: "center" }}>
                        ${" "}
                        {acreedor.monto
                          ? formatter.format(acreedor.monto)
                          : 0}{" "}
                      </TableCell>
                      <TableCell sx={{ textAlign: "center" }}>
                        {acreedor.detalle ?? "-"}
                      </TableCell>
                      <TableCell sx={{ textAlign: "center" }}>
                        <Button
                          variant="contained"
                          color="secondary"
                          onClick={() =>
                            quitarAcreedor(
                              servicio.contractServiceId,
                              acreedor,
                              acreedor.id
                            )
                          }
                          disabled={bloqueadoTotalmente} // 🔒
                        >
                          Quitar
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Grid2>
          ))
          : null}
        <Grid2 size={12} sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>

          {bloqueadoTotalmente ? (
            <Button
              type="button"
              variant="contained"
              color="success"
              startIcon={<SkipNext />}
              size="large"
              onClick={() => onChangeSave(2)}
            >
              Continuar
            </Button>
          ) : (
            <Button
              onClick={() => handleSubmit(false)}
              variant="contained"
              color="primary"
              startIcon={<AddIcon />}
              disabled={bloqueadoTotalmente}
            >
              GUARDAR Y CONTINUAR
            </Button>
          )}


        </Grid2>

      </Grid2>

      <Modal
        open={showAsignarCausas}
        onClose={() => setShowAsignarCausas(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleModalAsignaCausas}>
          <Typography sx={{ mb: 2 }} align="center" variant="h6">
            {" "}
            Asignar Causas a Servicio(s)
          </Typography>
          <TableContainer component={Paper}>
            <Table aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>Causa</TableCell>
                  <TableCell align="right">Servicio</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {causasList?.map((row) => (
                  <TableRow key={row.id}>
                    <TableCell align="left" sx={{ width: "60%" }}>
                      <ListItemText m={0} primary={`${row.rol}`} />
                      <ListItemText m={0} primary={`${row.tribunal}`} />
                      <ListItemText m={0} primary={`${row.demandante}`} />
                    </TableCell>
                    <TableCell align="right">
                      <TextField
                        label="Asignar Servicio"
                        select
                        required
                        fullWidth
                        value={row.serviceId ?? null}
                        onChange={(e) => handleAsignarServicioCausa(e, row)}
                        disabled={bloqueadoTotalmente} // 🔒
                      >
                        <MenuItem value={null} disabled> seleccione... </MenuItem>
                        {serviciosSeleccionados.map((servicio) => (
                          <MenuItem
                            key={servicio.idService}
                            value={servicio.idService}
                          > {servicio.name}
                          </MenuItem>
                        ))}
                      </TextField>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <Button
            sx={{ mt: 2 }}
            variant="outlined"
            onClick={() => handleSubmit(true)}
            disabled={bloqueadoTotalmente} // 🔒
          > Confirmar </Button>
        </Box>
      </Modal>
    </Paper>
  );
};

export default Servicios;
